// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProjectCont {
    background-color: white;
    padding: 5px;
    border-radius: 11px;
}

.addnewprojecthead {
    font-family: "Inter";
    font-size: 18px;
    font-weight: 600;
    line-height: 21.78px;
    letter-spacing: 0.02em;
    text-align: left;
    color: #0070E9
}

.labelproj {
    font-family: "Inter";
    font-size: 16px;
    font-weight: 600;
    line-height: 19.36px;
    letter-spacing: 0.02em;
    text-align: left;
    color: #0056B2;
    padding-left: 18px;

}

.editsetupmaincont {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.projsetupedit {
    width: 100%;
    /* max-width: 72px; */
    height: 34px;
    font-family: "Inter";
    font-size: 14px !important;
    padding: 15px !important;
    font-weight: 600 !important;
    line-height: 19.36px;
    letter-spacing: 0.02em;
    text-align: left;
    background-color: #FE602F !important;
    color: white !important;
    text-transform: none !important;
}
.projsetupeditOwner{
    width: 100%;
    /* max-width: 72px; */
    height: 34px;
    font-family: "Inter";
    font-size: 14px !important;
    padding: 15px !important;
    font-weight: 600 !important;
    line-height: 19.36px;
    letter-spacing: 0.02em;
    text-align: left;
    background-color: #FE602F !important;
    color: white !important;
    text-transform: none !important;

}

.removeTaskDisable{
    width: 100%;
    /* max-width: 72px; */
    height: 34px;
    font-family: "Inter";
    font-size: 14px !important;
    padding: 15px !important;
    font-weight: 600 !important;
    line-height: 19.36px;
    letter-spacing: 0.02em;
    text-align: left;
    background-color:  #d3d1d1 !important;
    color:#726f6f !important;
    text-transform: none !important;
    /* color: white !important */
}


.TableCellstart {
    font-family: "Inter";
    font-size: 14px !important;
    font-weight: 700 !important;
    line-height: 16.94px;
    letter-spacing: 0.02em;
    text-align: left;
    text-align: center;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    overflow: hidden !important;
    position: relative !important;
    color: #008A27 !important;
}


.TableCellend {
    font-family: "Inter";
    font-size: 14px !important;
    font-weight: 700 !important;
    line-height: 16.94px;
    letter-spacing: 0.02em;
    text-align: left;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    overflow: hidden !important;
    position: relative !important;
    color: #E90000 !important;
}

.projectOwnertable-header {
    color: #0070E9;
    font-size: 16px;
    font-weight: 700;
    padding: 20px;
}

.projectOwnerTable-body{
    color:rgb(57, 49, 49)!important;
    font-size: 14px;
    font-weight: lighter !important;
    padding-left: 20px !important;
}

.editvalue{
    font-family: "Inter";
    font-size: 16px;
    font-weight: 700;
    line-height: 19px;
    letter-spacing: 0.02em;
    text-align: left;
    color:  #0079E9;
    padding-top: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    
    
    }

    .editvalueDescnew{
        font-family: "Inter";
    font-size: 16px;
    font-weight: 700;
    line-height: 19px;
    letter-spacing: 0.02em;
    text-align: left;
    color:  #0079E9;
    padding-top: 10px;
  
    }

.addProjectOwnerPopup{
    color:#0056B2;
    font-weight: 600;
    padding: 5px;
    /* padding-left: 20px; */
    font-size: 15px;
}

.projectTaskTable-body{
    color:#375370!important;
    font-size: 12px;
    font-weight: lighter !important;
    padding-left: 20px !important;
    /* height: 41px !important; */
    /* font-family: 'inter' !important; */
}

.taskAssignUpdateButtons{
    display:flex;
     gap:2%;
     justify-content:end;
     text-align:right
}

@media only screen and (max-width: 1420px) {
    .employeeRosterMediaQuerycont{
        background-color: white;
        padding: 5px;
        border-radius: 11px;
      width: 73vw !important;
      /* border: 1px solid black !important; */
      justify-content: center;
      text-align: center;
      padding: 0.5vw;
    }
  }
  
  @media only screen and (min-width: 1440px) {
    .employeeRosterMediaQuerycont{
        background-color: white;
        padding: 5px;
        border-radius: 11px;
    width: 79vw !important; 
    /* min-width: 79vw !important; */
    /* width: 20vw !important; */
    /* border: 1px solid black !important; */
    justify-content: center;
    text-align: center;
    padding: 0.5vw;
    }
  }`, "",{"version":3,"sources":["webpack://./src/views/panel/Project/Project.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,gBAAgB;IAChB;AACJ;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;;AAEtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,YAAY;IACZ,oBAAoB;IACpB,0BAA0B;IAC1B,wBAAwB;IACxB,2BAA2B;IAC3B,oBAAoB;IACpB,sBAAsB;IACtB,gBAAgB;IAChB,oCAAoC;IACpC,uBAAuB;IACvB,+BAA+B;AACnC;AACA;IACI,WAAW;IACX,qBAAqB;IACrB,YAAY;IACZ,oBAAoB;IACpB,0BAA0B;IAC1B,wBAAwB;IACxB,2BAA2B;IAC3B,oBAAoB;IACpB,sBAAsB;IACtB,gBAAgB;IAChB,oCAAoC;IACpC,uBAAuB;IACvB,+BAA+B;;AAEnC;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,YAAY;IACZ,oBAAoB;IACpB,0BAA0B;IAC1B,wBAAwB;IACxB,2BAA2B;IAC3B,oBAAoB;IACpB,sBAAsB;IACtB,gBAAgB;IAChB,qCAAqC;IACrC,wBAAwB;IACxB,+BAA+B;IAC/B,4BAA4B;AAChC;;;AAGA;IACI,oBAAoB;IACpB,0BAA0B;IAC1B,2BAA2B;IAC3B,oBAAoB;IACpB,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;IAC9B,2BAA2B;IAC3B,kCAAkC;IAClC,2BAA2B;IAC3B,6BAA6B;IAC7B,yBAAyB;AAC7B;;;AAGA;IACI,oBAAoB;IACpB,0BAA0B;IAC1B,2BAA2B;IAC3B,oBAAoB;IACpB,sBAAsB;IACtB,gBAAgB;IAChB,8BAA8B;IAC9B,2BAA2B;IAC3B,kCAAkC;IAClC,2BAA2B;IAC3B,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,+BAA+B;IAC/B,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;;;IAGvB;;IAEA;QACI,oBAAoB;IACxB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;;IAEjB;;AAEJ;IACI,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,+BAA+B;IAC/B,6BAA6B;IAC7B,6BAA6B;IAC7B,qCAAqC;AACzC;;AAEA;IACI,YAAY;KACX,MAAM;KACN,mBAAmB;KACnB;AACL;;AAEA;IACI;QACI,uBAAuB;QACvB,YAAY;QACZ,mBAAmB;MACrB,sBAAsB;MACtB,wCAAwC;MACxC,uBAAuB;MACvB,kBAAkB;MAClB,cAAc;IAChB;EACF;;EAEA;IACE;QACI,uBAAuB;QACvB,YAAY;QACZ,mBAAmB;IACvB,sBAAsB;IACtB,gCAAgC;IAChC,4BAA4B;IAC5B,wCAAwC;IACxC,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd;EACF","sourcesContent":[".ProjectCont {\r\n    background-color: white;\r\n    padding: 5px;\r\n    border-radius: 11px;\r\n}\r\n\r\n.addnewprojecthead {\r\n    font-family: \"Inter\";\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n    line-height: 21.78px;\r\n    letter-spacing: 0.02em;\r\n    text-align: left;\r\n    color: #0070E9\r\n}\r\n\r\n.labelproj {\r\n    font-family: \"Inter\";\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    line-height: 19.36px;\r\n    letter-spacing: 0.02em;\r\n    text-align: left;\r\n    color: #0056B2;\r\n    padding-left: 18px;\r\n\r\n}\r\n\r\n.editsetupmaincont {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n.projsetupedit {\r\n    width: 100%;\r\n    /* max-width: 72px; */\r\n    height: 34px;\r\n    font-family: \"Inter\";\r\n    font-size: 14px !important;\r\n    padding: 15px !important;\r\n    font-weight: 600 !important;\r\n    line-height: 19.36px;\r\n    letter-spacing: 0.02em;\r\n    text-align: left;\r\n    background-color: #FE602F !important;\r\n    color: white !important;\r\n    text-transform: none !important;\r\n}\r\n.projsetupeditOwner{\r\n    width: 100%;\r\n    /* max-width: 72px; */\r\n    height: 34px;\r\n    font-family: \"Inter\";\r\n    font-size: 14px !important;\r\n    padding: 15px !important;\r\n    font-weight: 600 !important;\r\n    line-height: 19.36px;\r\n    letter-spacing: 0.02em;\r\n    text-align: left;\r\n    background-color: #FE602F !important;\r\n    color: white !important;\r\n    text-transform: none !important;\r\n\r\n}\r\n\r\n.removeTaskDisable{\r\n    width: 100%;\r\n    /* max-width: 72px; */\r\n    height: 34px;\r\n    font-family: \"Inter\";\r\n    font-size: 14px !important;\r\n    padding: 15px !important;\r\n    font-weight: 600 !important;\r\n    line-height: 19.36px;\r\n    letter-spacing: 0.02em;\r\n    text-align: left;\r\n    background-color:  #d3d1d1 !important;\r\n    color:#726f6f !important;\r\n    text-transform: none !important;\r\n    /* color: white !important */\r\n}\r\n\r\n\r\n.TableCellstart {\r\n    font-family: \"Inter\";\r\n    font-size: 14px !important;\r\n    font-weight: 700 !important;\r\n    line-height: 16.94px;\r\n    letter-spacing: 0.02em;\r\n    text-align: left;\r\n    text-align: center;\r\n    white-space: nowrap !important;\r\n    overflow: hidden !important;\r\n    text-overflow: ellipsis !important;\r\n    overflow: hidden !important;\r\n    position: relative !important;\r\n    color: #008A27 !important;\r\n}\r\n\r\n\r\n.TableCellend {\r\n    font-family: \"Inter\";\r\n    font-size: 14px !important;\r\n    font-weight: 700 !important;\r\n    line-height: 16.94px;\r\n    letter-spacing: 0.02em;\r\n    text-align: left;\r\n    white-space: nowrap !important;\r\n    overflow: hidden !important;\r\n    text-overflow: ellipsis !important;\r\n    overflow: hidden !important;\r\n    position: relative !important;\r\n    color: #E90000 !important;\r\n}\r\n\r\n.projectOwnertable-header {\r\n    color: #0070E9;\r\n    font-size: 16px;\r\n    font-weight: 700;\r\n    padding: 20px;\r\n}\r\n\r\n.projectOwnerTable-body{\r\n    color:rgb(57, 49, 49)!important;\r\n    font-size: 14px;\r\n    font-weight: lighter !important;\r\n    padding-left: 20px !important;\r\n}\r\n\r\n.editvalue{\r\n    font-family: \"Inter\";\r\n    font-size: 16px;\r\n    font-weight: 700;\r\n    line-height: 19px;\r\n    letter-spacing: 0.02em;\r\n    text-align: left;\r\n    color:  #0079E9;\r\n    padding-top: 10px;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    \r\n    \r\n    }\r\n\r\n    .editvalueDescnew{\r\n        font-family: \"Inter\";\r\n    font-size: 16px;\r\n    font-weight: 700;\r\n    line-height: 19px;\r\n    letter-spacing: 0.02em;\r\n    text-align: left;\r\n    color:  #0079E9;\r\n    padding-top: 10px;\r\n  \r\n    }\r\n\r\n.addProjectOwnerPopup{\r\n    color:#0056B2;\r\n    font-weight: 600;\r\n    padding: 5px;\r\n    /* padding-left: 20px; */\r\n    font-size: 15px;\r\n}\r\n\r\n.projectTaskTable-body{\r\n    color:#375370!important;\r\n    font-size: 12px;\r\n    font-weight: lighter !important;\r\n    padding-left: 20px !important;\r\n    /* height: 41px !important; */\r\n    /* font-family: 'inter' !important; */\r\n}\r\n\r\n.taskAssignUpdateButtons{\r\n    display:flex;\r\n     gap:2%;\r\n     justify-content:end;\r\n     text-align:right\r\n}\r\n\r\n@media only screen and (max-width: 1420px) {\r\n    .employeeRosterMediaQuerycont{\r\n        background-color: white;\r\n        padding: 5px;\r\n        border-radius: 11px;\r\n      width: 73vw !important;\r\n      /* border: 1px solid black !important; */\r\n      justify-content: center;\r\n      text-align: center;\r\n      padding: 0.5vw;\r\n    }\r\n  }\r\n  \r\n  @media only screen and (min-width: 1440px) {\r\n    .employeeRosterMediaQuerycont{\r\n        background-color: white;\r\n        padding: 5px;\r\n        border-radius: 11px;\r\n    width: 79vw !important; \r\n    /* min-width: 79vw !important; */\r\n    /* width: 20vw !important; */\r\n    /* border: 1px solid black !important; */\r\n    justify-content: center;\r\n    text-align: center;\r\n    padding: 0.5vw;\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
